import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Chip,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { relevance, status } from "../../../constants/constants-todo";

export const TodoTabSuggestions = () => {
  const [suggestions, setSuggestions] = useState([]);

  const traerSugerencias = async () => {
    try {
      const response = await fetch(`/api/v1/buzon?type=sugerencia`);
      const data = await response.json();

      if (!data.ok) {
        return;
      }

      //Darle formato a los datos
      data.data.forEach((suggestion) => {
        suggestion.relevance = relevance[suggestion.relevance];
        suggestion.status = status[suggestion.status];
      });

      setSuggestions(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    traerSugerencias();
  }, []);

  if (suggestions.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        No hay sugerencias
      </Typography>
    );
  }

  return (
    <>
      {suggestions.map((suggestion) => (
        <Accordion key={suggestion.id}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography variant="subtitle1">{suggestion.title}</Typography>
              <Typography variant="body2" color="textSecondary">
                {new Date(suggestion.date).toLocaleDateString()}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" color="textSecondary">
              {suggestion.description}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Chip
                label={suggestion.status.name}
                color={suggestion.status.color}
              />
              <Chip
                label={suggestion.relevance.name}
                color={suggestion.relevance.color}
              />
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
